import MeaPage from "../../components/MeaPage";
import { useRef, useState } from "react";
import TrainingsListComponent from "./components/TrainingsListComponent";
import TrainingsCardsComponent from "./components/TrainingsCardsComponent";
import MeaLink from "../../components/MeaLink";
import { useAuthContext } from "../../hooks/useAuthContext";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";

const TrainingsListPage = () => {
  const [viewMode, setViewMode] = useState('cards'); // 'cards' or 'list'
  const { currentMembership } = useAuthContext();
  const listRef = useRef();
  
  const breadcrum = [
    {
      label: 'Components',
      template: () => <MeaLink to={`/school/${currentMembership?.school?.id}/admin`} icon="pi pi-home" isRipple={true}>{currentMembership?.school?.name}</MeaLink>
    },
    { label: 'Formations' }
  ];

  const ViewSwitcher = () => (
    <div className="flex align-items-center gap-2">
      <div className="flex border-1 border-200 border-round">
        <Button
          icon="pi pi-th-large"
          className={`p-button-text ${viewMode === 'cards' ? 'bg-primary text-white' : 'text-600'}`}
          onClick={() => setViewMode('cards')}
          tooltip="Vue en cartes"
          tooltipOptions={{ position: 'bottom' }}
        />
        <Button
          icon="pi pi-list"
          className={`p-button-text ${viewMode === 'list' ? 'bg-primary text-white' : 'text-600'}`}
          onClick={() => setViewMode('list')}
          tooltip="Vue en liste"
          tooltipOptions={{ position: 'bottom' }}
        />
      </div>
    </div>
  );

  return (
    <>
      <MeaPage
        title="Formations"
        breadcrumb={<BreadCrumb model={breadcrum} />}
        customActions={<ViewSwitcher />}
      >
        <div className="p-3"> 
        {viewMode === 'cards' ? (
          <TrainingsCardsComponent
            ref={listRef}
            showAddButton={true}
          />
        ) : (
          <TrainingsListComponent
            ref={listRef}
            showAddButton={true}
            showFilterButton={true}
          />
        )}
        </div>
      </MeaPage>
    </>
  );
};

export default TrainingsListPage;
